import React from "react";
import classes from "./RequiredLabel.module.scss";

export function RequiredLabel() {

    return (
        <span className={classes.required}>必須</span>
    );
}

